import { useEffect, useRef } from "react";
import { useAuth } from "./contexts/AuthContext";
import { Toaster, toast } from "sonner";
import { Route, Routes } from "react-router-dom";
import ProtectedRoute from "./components/route-wrappers/ProtectedRoute";
import { DashboardPageLayout } from "./components/layouts/DashboardPageLayout";
import AuthRoute from "./components/route-wrappers/AuthRoute";
import NotFoundRoute from "./components/route-wrappers/NotFoundRoute";
import { authRoutes, dashboardRoutes, publicRoutes } from "@/config/routes";
import { getCookie } from "@/utils/cookies";

function App() {
  const { isAuth, logout } = useAuth();
  const wasAuthenticated = useRef(false);

  useEffect(() => {
    if (isAuth) {
      wasAuthenticated.current = true;
    }
  }, [isAuth]);

  useEffect(() => {
    const checkConnection = () => {
      const hasAuthCookie = getCookie("isAuth") === "true";
      if (wasAuthenticated.current && hasAuthCookie && !isAuth) {
        toast.error("Потеря соединения", {
          description: "Связь с сервером была потеряна. Выполняется переподключение...",
          duration: 5000,
        });
        wasAuthenticated.current = false;
        logout();
      }
    };

    const interval = setInterval(checkConnection, 5000);
    return () => clearInterval(interval);
  }, [isAuth, logout]);

  return (
    <div className="min-h-screen w-full bg-white">
      <Routes>
        <Route element={<ProtectedRoute />}>
          <Route element={<DashboardPageLayout />}>
            {dashboardRoutes.map((route) => (
              <Route key={route.path} path={route.path} element={route.element} />
            ))}
          </Route>
        </Route>

        <Route element={<AuthRoute />}>
          {authRoutes.map((route) => (
            <Route key={route.path} path={route.path} element={route.element} />
          ))}
        </Route>

        {publicRoutes.map((route) => (
          <Route key={route.path} path={route.path} element={route.element} />
        ))}

        <Route path="*" element={<NotFoundRoute />} />
      </Routes>

      <Toaster position="top-center" richColors toastOptions={{ style: { fontSize: "1rem" } }} />
    </div>
  );
}

export default App;
